export enum CardTypeKeys {
  CRD_CUSTOMER = 'CRD_CUSTOMER',
  CRD_EMPLOYEE = 'CRD_EMPLOYEE',
}
